"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AaHelpers = require("../../../utils/AaHelpers");

var mapTranslation = function mapTranslation(componentLabels) {
  return {
    result: {
      adultLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.adult', componentLabels),
      infantLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.infant', componentLabels),
      childLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.child', componentLabels)
    },
    adultLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.adult', componentLabels),
    infantLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.infant', componentLabels),
    childLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.child', componentLabels),
    adultDescLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.adultRange', componentLabels),
    infantDescLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.infantRange', componentLabels),
    childDescLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.childRange', componentLabels),
    paxDoneLabel: (0, _AaHelpers.getLabelBasedOnLocale)('main.paxDone', componentLabels),
    paxRoomLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.paxRoomLabel', componentLabels),
    roomLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.roomLabel', componentLabels),
    addMoreRoomsLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.addRoomLabel', componentLabels),
    moreRoomsWarningLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.moreRoomsWarning', componentLabels),
    removeRoom: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.removeRoom', componentLabels, 'Remove'),
    occupancyLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.roomAndGuest', componentLabels, 'Room & guest'),
    childAgeDropdownLabel: (0, _AaHelpers.getLabelBasedOnLocale)('hotels.childAgeDropdownLabel', componentLabels)
  };
};

var _default = mapTranslation;
exports["default"] = _default;